export const DMS_MODULE = 'Ciselniky';
